import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1185.92753,1581.17647 C1185.92753,1705.75059 1084.61929,1807.05882 960.045176,1807.05882 C835.471059,1807.05882 734.162824,1705.75059 734.162824,1581.17647 L1185.92753,1581.17647 Z M960.045176,225.882353 C1302.48282,225.882353 1581.22165,504.508235 1581.22165,847.058824 L1581.22165,1242.35294 C1581.22165,1329.09176 1613.97459,1408.26353 1667.62165,1468.23529 L252.355765,1468.23529 C306.115765,1408.26353 338.868706,1329.09176 338.868706,1242.35294 L338.868706,847.058824 C338.868706,504.508235 617.494588,225.882353 960.045176,225.882353 Z M1694.16282,1242.35294 L1694.16282,847.058824 C1694.16282,461.364706 1394.86871,144.790588 1016.51576,115.764706 L1016.51576,2.84217094e-14 L903.574588,2.84217094e-14 L903.574588,115.764706 C525.108706,144.790588 225.927529,461.364706 225.927529,847.058824 L225.927529,1242.35294 C225.927529,1366.92706 124.619294,1468.23529 0.0451764706,1468.23529 L0.0451764706,1581.17647 L621.221647,1581.17647 C621.221647,1767.98118 773.127529,1920 960.045176,1920 C1146.84988,1920 1298.86871,1767.98118 1298.86871,1581.17647 L1920.04518,1581.17647 L1920.04518,1468.23529 C1795.47106,1468.23529 1694.16282,1366.92706 1694.16282,1242.35294 L1694.16282,1242.35294 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconAlertsLine = /*#__PURE__*/function (_Component) {
  _inherits(IconAlertsLine, _Component);

  var _super = _createSuper(IconAlertsLine);

  function IconAlertsLine() {
    _classCallCheck(this, IconAlertsLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconAlertsLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconAlerts",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconAlertsLine.displayName = "IconAlertsLine";
  return IconAlertsLine;
}(Component);

IconAlertsLine.glyphName = 'alerts';
IconAlertsLine.variant = 'Line';
IconAlertsLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconAlertsLine;
export { IconAlertsLine };